import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GameSounds } from '@ezugi/bootstrap/src/store/types';

export type AppConfig = {
  sounds?: GameSounds;
  retailMode: boolean;
  promptStates: string[];
}

const initialState: AppConfig = {
  retailMode: false,
  promptStates: [],
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    start() {},
    stop() {},
    pause() {},
    resume() {},
    updateSoundsConfig(state, { payload } : PayloadAction<AppConfig['sounds']>) {
      return {
        ...state,
        sounds: payload,
      };
    },
  },
});

export const appActions = appSlice.actions;
export default appSlice.reducer;
